import React from 'react';
import PropTypes from 'prop-types';

import { AtomicText } from './Text';

const eyebrowDesign = {
  mobileDesign: {
    color: '#777777',
    'font-size': '13px',
    'letter-spacing': '1.517px',
    'line-height': '13px',
    'font-family': `'CentraNo2', sans-serif`,
    'font-weight': '700',
    'text-transform': 'uppercase',
    display: 'block'
  },
  tabletDesign: {
    'letter-spacing': '1.52px'
  },
  desktopDesign: {
    'font-size': '13px',
    'letter-spacing': '1.517px',
    'line-height': '13px'
  }
};
const Eyebrow = ({ text, className }) => (
  <AtomicText
    element="span"
    mobileDesign={eyebrowDesign.mobileDesign}
    tabletDesign={eyebrowDesign.tabletDesign}
    desktopDesign={eyebrowDesign.desktopDesign}
    className={className || 'eyebrow'}
  >
    {text}
  </AtomicText>
);

Eyebrow.defaultProps = {
  className: undefined
};

Eyebrow.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default Eyebrow;
